<template>
  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-6 col-md-12 col-sm-12">
        <BaseInput
            v-model="filters.name"
            :placeholder="$t('general.name')"
            :label="false"
            type="text">
        </BaseInput>
      </div>
      <div class="col-lg-2 col-sm-12 col-12 d-flex d-lg-block justify-content-center">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import BaseInput from '@/components/base/BaseInput.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  operationTypeDropdown: {
    type: Array,
    require: true,
  },
});

const emit = defineEmits(['search']);
const {filters} = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

</script>

<style scoped>
</style>
